import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgProgress} from '@ngx-progressbar/core';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../dataServices/userService';
import { UserEmailConfirmationModel } from './welcome-page.model';
import { AzureLoggerService } from 'src/app/services/azureLoggerService';

@Component({
    selector: 'self-ins-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent {
    @ViewChild('form', { static: false }) public form: NgForm | undefined;
    public email: string = '';
    public password: string = '';
    public submitted = false;

    public constructor(private router: Router,
                       private progressBar: NgProgress,
                       private activatedRoute: ActivatedRoute,
                       private toastrService: ToastrService,
                       private userStatusService: UserService,
                       private azureLoggerService: AzureLoggerService) 
    {}

    public onSubmit() {
        this.progressBar.ref().start();
        this.submitted = true;

        const userId = +this.activatedRoute.snapshot.queryParams['userId'];
        const token = this.activatedRoute.snapshot.queryParams['token'];

        // @ts-ignore
        if (!userId || !token || !this.form.valid) {
            this.router.navigate(['']);
        }

        const requestModel = {
            userId,
            token,
            password: this.password,
            email: this.email
        } as UserEmailConfirmationModel;

        this.userStatusService.confirmEmail(requestModel)
            .pipe(
                finalize(() => this.progressBar.ref().complete())
            )
            .subscribe(
                () => {},
                (_error) => {
                    this.toastrService.error('Unable to confirm email, please contact your system administrator.');
                    return;
                },
                () => {
                    this.toastrService.success('Successfully confirmed email.');
                    this.router.navigate(['']);
                });
    }
}